import { useContext, useMemo, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { ThemeContext } from '../../../../auth';
import axios from '../../../../api/axios';
import Swal from 'sweetalert2';
import { Formik } from 'formik';
import Select from 'react-select';

function ModalEditUser({
    showEditUser,
    setShowEditUser,
    rowSelected,
    retrieveUser,
    tokenUser,
    listDivisi
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const defaultValue = {
        first_name: rowSelected?.first_name || "",
        last_name: rowSelected?.last_name || "",
        username: rowSelected?.username || "",
        email: rowSelected?.email || "",
        group: listDivisi.find(divisi => divisi.name === rowSelected?.group_name)?.id || "",
    };

    const divisiOptions = useMemo(() =>
        listDivisi.map(divisi => ({
            value: divisi.id,
            label: divisi.name,
        })),
        [listDivisi]
    );

    const handleSelectDivisi = (selectedOption, setFieldValue) => {
        setFieldValue('group', selectedOption ? selectedOption.value : "");
    };

    const handleClose = () => {
        setShowEditUser(false);
    };

    const handleSubmitUser = async (values) => {
        setIsSubmitting(true);
        setDisabled(true);

        const dataUser = {
            first_name: values?.first_name,
            last_name: values?.last_name,
            groups: values?.group,
            email: values?.email
        };


        try {

            await axios.patch(`/account/user-retrieve/${rowSelected.id}/`, dataUser, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah user',
                showConfirmButton: true,
            });

            retrieveUser();

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah user',
            });
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? (state.isFocused ? 'red' : 'white') : (state.isFocused ? 'red' : '#222'),
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        menuList: (provided) => ({
            ...provided,
            padding: '0', // Remove extra padding
            maxHeight: '150px', // Reduce max height of dropdown
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '4px', // Reduce indicator padding
        }),
    };

    return (
        <Modal
            show={showEditUser}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Ubah User
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitUser}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='firstName'>Nama Depan*</Form.Label>
                                <Form.Control
                                    id='firstName'
                                    type='text'
                                    required
                                    value={values.first_name}
                                    onChange={handleChange("first_name")}
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='lastName'>Nama Belakang*</Form.Label>
                                <Form.Control
                                    id='lastName'
                                    type='text'
                                    required
                                    value={values.last_name}
                                    onChange={handleChange("last_name")}
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='division'>Divisi*</Form.Label>
                                <Select
                                    id='division'
                                    required
                                    options={divisiOptions}
                                    value={divisiOptions.find(option => option.value === values.group) || null}
                                    onChange={(selectedOption) => handleSelectDivisi(selectedOption, setFieldValue)}
                                    styles={selectStyles}
                                    placeholder='Select...'
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='userName'>Username*</Form.Label>
                                <Form.Control
                                    id='userName'
                                    type='text'
                                    required
                                    value={values.username}
                                    onChange={handleChange("username")}
                                    style={formStyles.input}
                                    readOnly
                                />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='email'>Email*</Form.Label>
                                <Form.Control
                                    id='email'
                                    type='email'
                                    required
                                    value={values.email}
                                    onChange={handleChange("email")}
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEditUser
